function Studiothink() {

  this.consts = {
    namespace: 'studiothink',
    breakpoints: {
      no: 0, 
      xs: 480,
      sm: 600,
      md: 782,
      lg: 960,
      xl: 1080,
      xxl: 1280,
      xxxl: 1440
    },
    breakpoint: 'lg',
    breakpointNav: 'xl',
    transition: {
      fast: 275,
      medium: 400,
      slow: 650
    }
  };
  
  this.viewPort = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    scrollBarY: window.innerWidth - document.documentElement.clientWidth,
    scrollBarX: window.innerHeight - document.documentElement.clientHeight,
  };
  this.uniqueIdLast = 0;
  
  this.header = {
    obj: document.querySelector( 'header.page-header' ),
    height: {
      no: 100,
      md: 110
    }
  }
  
  this.windowPageYOffsetLast = 0;
  
  this.sections = document.querySelectorAll( '.page-section' );
  
  var st = this;
  this.isSmallScreen = function( breakpoint ) {
    breakpoint = breakpoint || st.consts.breakpoint;
    return ( st.consts.breakpoints[ breakpoint ] > st.viewPort.width );
  };
  this.isSmallScreenNav = function() {
    return ( st.consts.breakpoints[ st.consts.breakpointNav ] > st.viewPort.width );
  };
  
  this.resize = function() {
    
    st.viewPort.width = document.documentElement.clientWidth;
    st.viewPort.height = document.documentElement.clientHeight;
    
    document.documentElement.style.setProperty('--vh',st.viewPort.height*.01+'px');
    document.documentElement.style.setProperty('--vw',st.viewPort.width*.01+'px');
    
    for ( var i = 0; i < this.sections.length; i++ ) {
      this.sections[i].style.width = st.viewPort.width + 'px';
    }
    
  };

  this.uniqueId = function( prefix ) {
    
    var id = '' + ++st.uniqueIdLast;
    return prefix ? prefix + id : 'st-' + id;
  };
    
  function init() {
    
    if ( window.st ) return false;
    
    document.documentElement.classList.add('st-initialized');
    if ( 'ontouchstart' in document.documentElement ) document.documentElement.classList.add('st-touch');
    if ( st.header.height.md <= window.pageYOffset ) document.documentElement.classList.add('st-scrolling');
    
    st.resize();


    return true;

  }
  init();
  
  window.st = window.st || this;
  
}
new Studiothink();

( function( $ ) {

  $( document ).ready( function() {

    $('.wp-block-cover.is-style-hero-cover > span[class*="has-background"]').each( function() {
      this.parentNode.className += ' ' + this.className;
      this.style.display = 'none';
    } );

    $('.wp-block-cover.is-style-hero > div.wp-block-cover__inner-container').append('<b class="hero__line"></b>');

    const today = new Date();
    const year = today.getFullYear();

    if($('#footer__year').text() != year) {
      $('#footer__year').text(year);
    }

    document.documentElement.classList.add( 'wp59fix' );

    st.resize();
      
    st.windowPageYOffsetLast = window.pageYOffset;
    
    $(window).on( 'load', function() {

      if(!st.isSmallScreen()) {
        document.querySelectorAll('.wp-block-cover video[data-src]').forEach(video => {
          video.src = video.dataset.src;
          video.removeAttribute('data-src');
          video.load();
        });

        $('html').addClass('load-vid');
      }


    } ).on( 'resize orientationchange', function() {

      st.resize();
      if ( document.documentElement.classList.contains( 'toggle-main-nav' ) && !st.isSmallScreenNav() ) document.documentElement.classList.remove( 'toggle-main-nav' );

      if ( !st.isSmallScreen() ) {
        if(!$('html').hasClass('load-vid')) {
            document.querySelectorAll('.wp-block-cover video[data-src]').forEach(video => {
            video.src = video.dataset.src;
            video.removeAttribute('data-src');
            video.load();
          });
          $('html').addClass('load-vid');
        }
      } else {

      }
      
    } ).on( 'scroll', function( e ) {

      if ( 0 === window.pageYOffset ) document.documentElement.classList.remove( 'is-scrolling' );
      else document.documentElement.classList.add( 'is-scrolling' );

      if ( 0 === window.pageYOffset || st.windowPageYOffsetLast < window.pageYOffset ) document.documentElement.classList.remove( 'is-scrolling-up' );
      else document.documentElement.classList.add( 'is-scrolling-up' );

      st.windowPageYOffsetLast = window.pageYOffset;

      if ( window.pageYOffset > 0) {
        document.querySelector('#site-header').classList.add('header--scrolled');

      } else {
        document.querySelector('#site-header').classList.remove('header--scrolled');
      }

      if ( 150 < window.pageYOffset ) {
        document.documentElement.classList.add('scrolled');
      } else {
        document.documentElement.classList.remove('scrolled');
      }

      $('.services__nav').each(function() {
        const $this = $(this);
        const elementTop = $this.offset().top;
        let scrollTop = $(window).scrollTop();
        let distance = elementTop - scrollTop;

        if (distance <= -50) {
          if (!$this.hasClass('is-fixed')) {
            $this.css('min-height', $this.outerHeight());
            setTimeout(function() {
              $this.addClass('is-fixed');
            }, 200);
          }
        } else {
          if ($this.hasClass('is-fixed')) {
            $this.removeClass('is-fixed');
            setTimeout(function() {
              $this.css('min-height', '');
            }, 300);
          }
        }
      });

    } ).on( 'hashchange', function( e ) {
      
      if ( window.location.hash.match( /^#?!\// ) ) {
        
        e.preventDefault();
        st.hashParts = window.location.hash.replace( /\/$/, '').split('/');
        
        if ( 'string' === typeof st.hashParts[1] ) {
          
          if ( 'top' === st.hashParts[1] ) {
            
            $( 'html, body' ).stop( true ).animate( { scrollTop: 0 }, st.consts.transition.slow );
            if ( 'replaceState' in history ) history.replaceState( undefined, document.title, window.location.pathname );
            
          } else if ( 'undefined' === typeof st.hashParts[2] && $( '#' + st.hashParts[1] ).length ) {
            
            var $target = $( '#' + st.hashParts[1] );
            $('html, body').stop( true ).animate( { scrollTop: $target.offset().top }, st.consts.transition.slow, function() {
              
            } );
          
          } else if ( st.hashParts[1].length && 'string' === typeof st.hashParts[2] ) {
            
            if ( 0 < st.hashParts[2].length ) {
              
              switch( st.hashParts[1] ) {
                case '':                
                  break;
              }

            }

          }

          if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );
          
        }
        return false;
      }
      
    } ).trigger( 'scroll' );
    if ( window.location.hash.length ) $( window ).trigger( 'hashchange' );

    $( '#toggle-main-nav' ).on( 'click', function( e ) {
      
      e.preventDefault();
      
      if ( document.documentElement.classList.contains( this.id ) ) {
        document.documentElement.classList.remove( 'animate' );
        document.documentElement.classList.remove( this.id );
        document.getElementById( this.id ).setAttribute('aria-expanded', false);
      } else {
        document.documentElement.classList.add( this.id );
        document.getElementById( this.id ).setAttribute('aria-expanded', true);
        setTimeout(function() {
          document.documentElement.classList.add( 'animate' );
        }, 150);
      }
      
    } );

    $('#menu-main-menu > li:last-of-type > a').on('click', function() {
      document.documentElement.classList.remove( 'animate' );
      document.documentElement.classList.remove( 'toggle-main-nav');
      document.getElementById( this.id ).setAttribute('aria-expanded', false);
    });

    const $menuItemContainers = $('.nav__main-wrap > div > ul > li, #menu-phone-1 > li');
    let $prevDelay = 0.15;

    $menuItemContainers.each(function() {
      $(this).css('transition-delay', `${$prevDelay}s`);
      $prevDelay += 0.15;
    });

    var submenus = document.body.querySelectorAll('.menu-item-has-children');
    for (var i = 0; i < submenus.length; i++) {
      submenus[i].addEventListener('click', function(e){
        if ( $(this).hasClass('sub-menu-toggled') ) {
          $(this).removeClass('sub-menu-toggled');
        } else {
          $(this).addClass('sub-menu-toggled');
        }
      }); 
    }

    //lity on video link//
    $('.wp-block-button__link').each( function() {
      var is_video = false;
      if ( 'string' === typeof this.href ) {
        if ( -1 !== this.href.indexOf( 'youtu.be' ) ) is_video = true;
        // if ( -1 !== this.href.indexOf( '.youtube.' ) ) is_video = true;
        if ( -1 !== this.href.indexOf( '.mp4' ) ) is_video = true;
        if ( -1 !== this.className.indexOf( 'button-video' ) ) is_video = true;
        if ( -1 !== this.parentNode.className.indexOf( 'button-video' ) ) is_video = true;
      }
      if ( true === is_video && 'function' === typeof lity ) {
        if ( -1 === this.className.indexOf( 'button-video' ) ) this.className += ' button-video';
        this.setAttribute( 'data-lity-extra' , 'true' );
      }
    } );
    $( document ).on( 'click', '[data-lity-extra]', lity);


    // get your select element and listen for a change event on it
    // set the window's location property to the value of the option the user has selected
    $('#select-cat').on('change' ,function(e) {
      window.location = $(this).val();
    });

    $('#cta-close').on('click', function() {
      //$(this).parent().slideUp();
      $(this).parent().animate({
        'right': '-440px'
      }, 300, function() {
        $(this).hide();
      });
    });

    setTimeout(function() {
      document.documentElement.classList.add('lineanimate');
    }, 2500);

    const $heroItems = $('#site-header, .wp-block-cover.is-style-hero > div.wp-block-cover__inner-container > *:not(.hero__line)');
    let $heroDelay = 0.25;
    $('.is-style-hero').addClass('animate');

    $('#site-header').addClass('animate');

    $heroItems.each(function() {
      $(this).css('transition-delay', `${$heroDelay}s`);
      $heroDelay += 0.4;
    });

    setTimeout(function() {
      $heroItems.each(function() {
        $(this).css('transition-delay', `0s`);
      });
    }, 7000);

    //copy blog link
    $('#copy-link').on('click', function(e) {
      e.preventDefault();
      var text = $(this).attr('value');
      var elem = document.createElement("textarea");
      document.body.appendChild(elem);
      elem.value = text;
      elem.select();
      document.execCommand('copy');
      document.body.removeChild(elem);
    });



    const resetSections = ($allSections, $navItems) => {
      $allSections.each(function() {
        if($(this).hasClass('active')) $(this).fadeOut();
      })

      $navItems.each(function() {
        $(this).removeClass('active');
      })
    }

    const keepHeight = ($serviceSection) => {
      const currentHeight = $serviceSection.height();
      $serviceSection.css('min-height', currentHeight);
    }

    const toggleSections = ($button, $allSections, $serviceSection, isInitial) => {
      $button.addClass('active');
      const $id = $button.data('section');

      $serviceSection.find(`#${$id}`).fadeIn().addClass('active');

      if(!isInitial) {
        $('html, body').animate({
          scrollTop: $serviceSection.offset().top - 50
        }, 600);
      }

      setTimeout(function() {
        $serviceSection.css('min-height', '0px');
      }, 400);
    }

    $('.services__nav').each(function() {
      const $navItems = $(this).find('button');
      const $serviceSection = $(this).next();
      const $associatedSections = $serviceSection.find('.service-section');

      $navItems.each(function() {
        const $this = $(this);
        $this.on('click', function(e) {
          e.preventDefault();

          if(!$this.hasClass('active')) {
            keepHeight($serviceSection);

            setTimeout(function() {
              resetSections($associatedSections, $navItems);
            }, 100);

            setTimeout(function() {
              toggleSections($this, $associatedSections, $serviceSection, false);
            }, 600);
          }
        });
      });

      //set initial states
      $associatedSections.each(function() {
        $(this).fadeOut('100');
      })

      setTimeout(function() {
        const $navItem = $navItems.first();
        toggleSections($navItem, $associatedSections, $serviceSection, true);
      }, 800);
    });


    //sliders-------------------------------//
    document.querySelectorAll('.wp-block-media-text.is-slider').forEach(mediaTextBlock => {
      // Find the slider pair within this specific block
      const mediaSliderEl = mediaTextBlock.querySelector('.slider--media');
      const contentSliderEl = mediaTextBlock.querySelector('.slider--content');
      
      if (!mediaSliderEl || !contentSliderEl) return;

      // Initialize media slider
      const mediaSlider = new Splide(mediaSliderEl, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
        speed: 800
      });

      // Initialize content slider
      const contentSlider = new Splide(contentSliderEl, {
        type: 'fade',
        perPage: 1,
        perMove: 1,
        gap: 0,
        padding: 0,
        pagination: false,
        arrows: false,
        rewind: true,
        speed: 800
      });

      // Mount and sync the pair
      mediaSlider.sync(contentSlider);
      mediaSlider.mount();
      contentSlider.mount();

      // Update counter for this specific pair
      const counter = mediaTextBlock.querySelector('.slider__count span');
      if (counter) {
        mediaSlider.on('move', (newIndex) => {
          counter.textContent = String(newIndex + 1).padStart(2, '0');
        });
      }
    });

    const sliders = document.querySelectorAll('.slider--posts');
    
    sliders.forEach(slider => {
        // Initialize with mobile-first settings
        let splide = new Splide(slider, {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            padding: { right: '150px', left: '150px' }, // Creates the peek effect
            pagination: false,
            arrows: true,
            breakpoints: {
                960: {
                    perPage: 1, // Show 2 posts
                    padding: { right: '100px', left: '30px' }, // Maintain 50px peek
                    destroy: false,
                    gap: 30
                },
                768: {
                  perPage: 1,
                  gap: 0,
                  padding: 0,
                  destroy: false // Ensures the slider doesn't destroy on resize
                },

            }
        });

        // Mount the slider
        splide.mount();

    });

    const logoSliders = document.querySelectorAll('.slider--logo');
    logoSliders.forEach((e) => {

      let args = {
          type: 'loop',
          fixedWidth: '220px',
          perMove: 1,
          perPage: 5,
          gap: 250,
          padding: 0,
          pagination: false,
          arrows: false,
          focus:'center',
          drag: true,
          autoplay: true,
          interval: 5000,
          pauseOnHover: true,
          pauseOnFocus: true,
          breakpoints : {
            1440: {
              perPage: 5,
            },
            1080: {
              perPage: 3,
              gap: 200,
              padding: {
                left: 60, right: 60
              }
            },
            780: {
              perPage: 1,
              fixedWidth: '180px',
              padding: {
                left:60, right: 60
              }
            },
            600: {
              perPage: 1,
              padding: 0,
              gap: 100
            },
          },
          // autoScroll: {
          //   speed: 1,
          //   pauseOnHover: false,
          // },
        }

      const splide = new Splide(e, args);
      // When the transition starts:
      splide.on('move', (newIndex, oldIndex) => {
        const slides = splide.Components.Slides.get();
        slides.forEach((slide) => slide.slide.classList.remove('active'));

        const newSlide = slides[newIndex];
        if (newSlide) newSlide.slide.classList.add('active');
      });

      // Initialize default active slide on load
      splide.on('mounted move', () => {
        const slides = splide.Components.Slides.get();
        slides.forEach((slide) => slide.slide.classList.remove('active'));

        const current = splide.Components.Slides.getAt(splide.index);
        if (current) current.slide.classList.add('active');
      });
      splide.mount();
    });
    
    //end sliders----------------------------//

    //Resources Sort Form//
    const $sortForm = $('#sort-form');

    $sortForm.on('submit' ,function(e) {
      $(this)[0].action = `${window.location.origin}/blog`;
    });

    $('#category').on('change', function() {
      $sortForm.trigger('submit');
    });

    $('#author').on('change', function() {
      $sortForm.trigger('submit');
    });
        

    $( 'footer.footer form' ).on( 'submit', function( e ) {
      e.preventDefault();
  
      var $this = $(this);
        
      if ( !$this.children( 'input[type="email"]' ).val().length || -1 === $this.children( 'input[type="email"]' ).val().indexOf('@') ) return false;
      
      var post = $.ajax({
        type: 'POST',
        url: '/wp-json/' + st.consts.namespace + '/v1/signup',
        data: { email: $this.children( 'input[type="email"]' ).val() },
        dataType: 'json'
      });
      
      post.done( function() {
        var $response = $( '<form><p>Thanks for subscribing!</p></form>' );
        $this.replaceWith( $response );
        setTimeout( function() {
          $response.fadeOut( 625, function() {
            $(this).remove();
          } );
        }, 5000 );
      })
      .fail( function() {
        $this.replaceWith( '<form><p>Error processing subscription! Please <a href="/connect/">contact us</a></p></form>' );
      })
      
      return false;
    } );

    //infinite scroll for paginated resource lists
    if ( 'IntersectionObserver' in window && 'fetch' in window && 'DOMParser' in window ) {

      $( '.resource__list__wrapper' ).each( function() {

        var wrapper = this,
            $list = $( wrapper ).children( 'ul.resource__list' ).first(),
            nav = wrapper.querySelector( '.navigation.pagination' );

        if ( !$list.length || !nav || !nav.querySelector( 'a.next' ) ) return;

        wrapper.classList.add( 'infinite-scroll-active' );

        var sentinel = document.createElement( 'div' );
        sentinel.className = 'posts-load-sentinel';
        sentinel.setAttribute( 'aria-hidden', 'true' );
        $list.after( sentinel );

        var loading = false,
            postsObserver;

        var loadNext = function() {

          var nextLink = nav.querySelector( 'a.next' );
          if ( !nextLink || loading ) return;

          loading = true;
          sentinel.classList.add( 'is-loading' );

          fetch( nextLink.href, { credentials: 'same-origin' } )
            .then( function( response ) {
              if ( !response.ok ) throw new Error( response.status );
              return response.text();
            } )
            .then( function( html ) {

              var doc = new DOMParser().parseFromString( html, 'text/html' ),
                  items = doc.querySelectorAll( '.resource__list__wrapper ul.resource__list > li.resource__listing' ),
                  newNavLinks = doc.querySelector( '.navigation.pagination .nav-links' ),
                  currentNavLinks = nav.querySelector( '.nav-links' );

              for ( var i = 0; i < items.length; i++ ) {

                ( function( node, i ) {

                  node.classList.add( 'observing' );
                  $list[0].appendChild( node );

                  if ( 'undefined' !== typeof observeSection ) observeSection.observe( node );
                  else window.setTimeout( function() { node.classList.add( 'intersected' ); }, 75 + ( i * 125 ) );

                } )( items[i], i );

              }

              if ( newNavLinks && currentNavLinks ) currentNavLinks.innerHTML = newNavLinks.innerHTML;

              if ( 'replaceState' in history ) history.replaceState( undefined, doc.title, nextLink.href );

              loading = false;
              sentinel.classList.remove( 'is-loading' );

              if ( !nav.querySelector( 'a.next' ) ) postsObserver.unobserve( sentinel );

            } )
            .catch( function() {

              // Reveal the standard pagination so the visitor can continue manually.
              postsObserver.unobserve( sentinel );
              wrapper.classList.remove( 'infinite-scroll-active' );
              sentinel.classList.remove( 'is-loading' );
              loading = false;

            } );

        };

        postsObserver = new IntersectionObserver( function( entries ) {
          if ( entries[0].isIntersecting ) loadNext();
        }, { rootMargin: '600px' } );

        postsObserver.observe( sentinel );

      } );

    }


//Generate TOC from h2s in content
// $( '.resource__single-content' ).one( 'init', function( e ) {
  $( '.resource__single__wrap' ).one( 'init', function( e ) {

  // Store the current content wrapper as variable $this for future use.
  var $this = $(this);
  
  // Create a new 'DIV' DOM element with class .toc as variable $toc.
  var $toc = $( '<div></div>' ).addClass( 'toc' );


  // Find every instance of an 'H2' DOM element wtihin the content wrapper. Loop through each of them.
  $this.find( 'h2' ).each( function() {

    // Give this H2 element an ID generated from the text within the H2 and sanitized to be HTML safe.
    // This assumes that all H2 elements have unique text. Things misbehave if two H2's have identical text.
    // this.id = 'toc-' + this.textContent.trim().toLowerCase().replace( /[^a-z0-9- ]/, '').replace( /[- ]+/, '-' )
    // this.id = 'toc-' + this.textContent.trim().toLowerCase().replace( /[^a-z0-9- ]/g, '').replace( /[- ]+/g, '-' )
    this.id = st.uniqueId( 'toc' );

    // If the H2 contains a <sup>, use its text for the TOC anchor title; otherwise use the full text of the H2.
    var $sup = $( this ).find( 'sup' );
    var tocText = $sup.length ? $sup.first().text().trim() : this.textContent.trim();

    // Create a new 'A' DOM element, assign its HREF attribute to anchor to the element ID you just created. Set the text of the anchor tag to match the text of the H2.
    // Append this anchor tag to the $toc variable you created at the start.
    $toc.append( $( '<a class="anchorlink"></a>' ).attr( 'href', '#!/' + this.id ).text( tocText ) );

  } );

  // Once you've looped through all of the H2's if there is at least one anchor tag added to the $toc variable insert the content at the beginning of the content wrapper.
  // Also gives the content wrapper an extra "has-toc" class for use as needed.
  if( $toc.children().length ) {
    $this.addClass( 'has-toc' ).prepend( $toc );
  }

} ).trigger( 'init' );
  
  

  //Accordion for WWO page. 

  $( '.accordion-header-text' ).on( 'click', function( e ) {
  e.preventDefault();

  if ( this.parentNode.parentNode.classList.contains( 'active' ) ) {
    this.parentNode.parentNode.classList.remove( 'active' );
    $( this ).next('.panel').slideUp();
  } else {
    this.parentNode.parentNode.classList.add( 'active' );
    $( this ).next('.panel').slideDown();
  }




} ).parent().next('.panel').hide();

    if ( 'IntersectionObserver' in window ) {
  
      var observeSection = new IntersectionObserver( function( entries ) {
        
        entries.forEach( function( entry ) {
        
          var content = entry.target;
          if ( entry.isIntersecting ) {
            
            content.classList.add( 'intersected' );
            content.classList.add( 'intersecting' );
            
          } else {
            
            content.classList.remove( 'intersecting' );

            if ( content.classList.contains( 'intersected' ) ) observeSection.unobserve( content );
            
          }
          
        });
        
      }, {
        threshold: 0.1
      });
      
      var contentNodes = document.querySelectorAll( '.content, .wp-block-group__inner-container > *:not(div), .wp-block-group .wp-block-column > *:not(h4):not(.is-style-hero-cta), .wp-block-cover:not(.is-style-hero) > .wp-block-cover__inner-container > *:not(is-style-hero-cta):not(div), .wp-block-media-text > figure, .wp-block-media-text__content > *:not(div), .wp-block-column > *:not(div:not(.wp-block-buttons)):not(h4)' );

 
      
      for( var i = 0; i < contentNodes.length; i++ ) {
        contentNodes[i].classList.add( 'observing' );
        observeSection.observe( contentNodes[i] );
      }
      
    }

    // var heroCta = document.querySelector( '.is-style-cta' );
    // if ( heroCta ) {
    //   heroCta.classList.add( 'observing' );
    // }

    //Make sure the anchor text is visible when clicking from the TOC
    $('a[class=anchorlink]').on( 'click', function( e ) {
      e.preventDefault();
      var targetid = this.hash.replace( '#', '' ).replace( '/', '' ).replace( '!', '' );
      var target = document.querySelector( 'h2#' + targetid );

        var headerOffset = 150;
        var elementPosition = target.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
        });

  } );

    // Align h3+h5 heights in team-four columns on lg+ screens
    let resizeTimer;
    function alignTeamFourHeights() {
      if (st.isSmallScreen('lg')) {
        // Reset heights on smaller screens
        $('.team-four h5').css('padding-bottom', '');
        return;
      }

      // Reset all padding-bottom before recalculating to prevent compounding
      $('.team-four h5').css('padding-bottom', '');

      $('.team-four').each(function() {
        const $teamFour = $(this);
        const $columns = $teamFour.find('.wp-block-column');
        let maxHeight = 0;
        const heights = [];

        // Calculate combined h3+h5 height for each column
        $columns.each(function() {
          const $h3 = $(this).find('h3');
          const $h5 = $(this).find('h5');
          const combinedHeight = $h3.outerHeight() + $h5.outerHeight();

          heights.push({
            $h5: $h5,
            combinedHeight: combinedHeight
          });
          if (combinedHeight > maxHeight) {
            maxHeight = combinedHeight;
          }
        });

        // Adjust h5 heights to match the maximum
        heights.forEach(function(item) {
          if (item.combinedHeight < maxHeight) {
            const difference = maxHeight - item.combinedHeight;
            item.$h5.css('padding-bottom', '+=' + difference);
          }
        });
      });
    }

    // Run on window load to ensure images are loaded
    $(window).on('load', alignTeamFourHeights);

    // Debounce resize event
    $(window).on('resize orientationchange', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(alignTeamFourHeights, 250);
    });
      
  } );


} )( jQuery );

